export default "__VITE_ASSET__40fNOCxg__"